module.exports = __webpack_public_path__ + "static/flybit_profile@2x-d441d69c3acd757cf103937c39da9b45.png";